import styled from 'styled-components';

export const Content = styled.div`
  height: 513px;
`;

export const SmallTitle = styled.h3`
  font-family: Lato;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  margin-top: 26px;
`;
